<template>
  <div class="co-product-images">
    <LightGallery
        :settings="{ licenseKey:'03A332BF-9CED-4313-943E-1CF4DEBD4380', speed: 500, plugins, selector : '.co-product-images__trigger' }"
        :onInit="onInit"
        :onBeforeSlide="onBeforeSlide"
        class="co-product-images__wrap"
    >
      <div class="co-product-images__preview">
        <a
          v-if="images.length"
          class="co-product-images__trigger zoomable js-zoom"
          :href="images[0].href"
          @mousemove="zoomMainImg"
          @touchmove="zoomMainImg"
          :data-src="images[0].href"
          :aria-label="'Main Image'"
          :style="{ backgroundImage: `url(${images[0].zoom})` }"
        >
          <img :alt="images[0].alt" :src="images[0].zoom" />
        </a>
      </div>

      <div class="co-product-images__thumbs" v-if="images.length > 1">
        <a
            class="co-product-images__thumb co-product-images__trigger"
            v-for="(item, i) in images.slice(1)"
            :key="'img' + i"
            :aria-label="'Image ' + (i + 2)"
            :data-iframe="item.type === 'iframe' ? 'true' : null"
            :data-src="['video'].includes(item.type) ? null : item.href"
            :data-poster="item.type === 'video' ? item.large_thumb : null"
            :data-sub-html="item.subHtml || null"
            :data-video="item.type === 'video' ? JSON.stringify(item.video) : null"
          >
            <img :src="item.small_thumb" :alt="item.alt"/>
            <i v-if="item.type === 'video'" class="fa fa-play video-icon"></i>
            <svg v-if="item.type === 'iframe'" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate3d-icon lucide-rotate-3d"><path d="M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2"/><path d="m15.194 13.707 3.814 1.86-1.86 3.814"/><path d="M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4"/></svg>
          </a>
      </div>
    </LightGallery>
  </div>
</template>

<script>
import LightGallery from 'lightgallery/vue';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

export default {
  name: 'ProductGallery',
  components: {LightGallery},
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      plugins: [lgThumbnail, lgZoom, lgVideo]
    };
  },
  methods: {
    onInit() {
    },
    onBeforeSlide() {
    },
    zoomMainImg(e) {
      const zoomer = e.currentTarget;
      let offsetX, offsetY;

      if (e.offsetX !== undefined) {
        offsetX = e.offsetX;
        offsetY = e.offsetY;
      } else if (e.touches && e.touches.length) {
        const rect = zoomer.getBoundingClientRect();
        offsetX = e.touches[0].pageX - rect.left;
        offsetY = e.touches[0].pageY - rect.top;
      }

      if (offsetX !== undefined && offsetY !== undefined) {
        const x = (offsetX / zoomer.offsetWidth) * 100;
        const y = (offsetY / zoomer.offsetHeight) * 100;
        zoomer.style.backgroundPosition = `${x}% ${y}%`;
      }
    }
  }
};
</script>

<style>
@import 'lightgallery/css/lightgallery.css';
@import 'lightgallery/css/lg-thumbnail.css';
@import 'lightgallery/css/lg-zoom.css';
@import 'lightgallery/css/lg-video.css';

.co-product-images__wrap {
  display:flex;
  gap:10px;
}

.co-product-images__preview {
  display: block;
  background-size: 200%;
  background-position: center;
  width: 100%;
  order:1;
}

.co-product-images__preview a {
  display: block;
}

.co-product-images__preview img {
  width:100%;
}

.co-product-images__thumbs {
  display: flex;
  gap: 10px;
  flex-direction: column;
  width: 80px;
  flex-shrink: 0;
  order:0;
}

.co-product-images__thumbs img {
  aspect-ratio: 4 / 3;
  object-fit: cover;
  width:100%;
}

.co-product-images__thumb {
  position: relative;
  cursor: pointer;
}

.co-product-images__thumb svg,
.video-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2em;
  color: white;
}

.co-product-images__thumb:has(i),
.co-product-images__thumb:has(svg) {
  background: rgba(0,0,0,1);
}
.co-product-images__thumb:has(i) img,
.co-product-images__thumb:has(svg) img {
  opacity: .8;
}

@media (max-width:900px){
  .co-product-images__wrap {
    flex-direction: column;
  }

  .co-product-images__thumbs {
    flex-direction: row;
    width: 100%;
    order:1;
  }

  .co-product-images__preview {
    order:0;
  }
}


</style>
